/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-29 10:47:51 */

const Keys = {
  addOperation: 'addOperation',
  upgradeOperation: 'upgradeOperation',
  loading: 'loading',
  itemTypeExtraLabel: {
    Extra: 'itemTypeExtraLabel.Extra',
    Tour: 'itemTypeExtraLabel.Tour',
    ActivitiesAndExcursions: 'itemTypeExtraLabel.ActivitiesAndExcursions',
    Dining: 'itemTypeExtraLabel.Dining',
    LoungeAccess: 'itemTypeExtraLabel.LoungeAccess',
    MeetAndGreet: 'itemTypeExtraLabel.MeetAndGreet',
    ChauffeuredServices: 'itemTypeExtraLabel.ChauffeuredServices',
    Flight: 'itemTypeExtraLabel.Flight'
  },
  priceChangeMessage: 'priceChangeMessage',
  priceChangeButtonLabel: 'priceChangeButtonLabel',
  dateDay: 'dateDay',
  from: 'from',
  serviceLabelHotel: 'serviceLabelHotel',
  unitLabelHotel: 'unitLabelHotel',
  serviceLabelRentalCar: 'serviceLabelRentalCar',
  serviceLabelTransfer: 'serviceLabelTransfer',
  additionalServicesHeader: 'additionalServicesHeader',
  loadingError: 'loadingError',
  soldOutError: 'soldOutError',
  priceChangeHeading: 'priceChangeHeading',
  additionalInformation: 'additionalInformation',
  addToCart: 'addToCart',
  subItemType_HOTEL: 'subItemType_HOTEL',
  subItemType_TOUR: 'subItemType_TOUR',
  subItemType_FLIGHT: 'subItemType_FLIGHT',
  subItemType_EXTRA: 'subItemType_EXTRA',
  subItemType_CHAUFFEURED_SERVICE: 'subItemType_CHAUFFEURED_SERVICE',
  subItemType_TRANSFER: 'subItemType_TRANSFER',
  subItemType_AIRPORT_TRANSFER: 'subItemType_AIRPORT_TRANSFER',
  subItemType_DINING: 'subItemType_DINING',
  subItemType_LOUNGE_ACCESS: 'subItemType_LOUNGE_ACCESS',
  subItemType_MEET_AND_GREET: 'subItemType_MEET_AND_GREET',
  packagePriceInfo: 'packagePriceInfo'
}; export default Keys;